module.exports = __webpack_public_path__ + "img/logo-cving.d1aad1ca.svg";